export function getBasePageName(path) {
    return path.split('/').filter((el) => Boolean(el))[0];
}
